// src/api/puntuacionApi.js
import { CALL_API } from "../context/constValues";
import { getAuthToken } from "../context/auth-context";

// ✅ Guardar o editar puntuación de un profesional
export async function savePuntuacionProfesional(objeto) {
  const {
    IdLegajoEnfermeria,
    IdProfesional,
    IdPacientes,
    Puntuacion,
    Comentario,
  } = objeto;

  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/savepuntuacionprofesional`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      IdLegajoEnfermeria,
      IdProfesional,
      IdPacientes,
      Puntuacion,
      Comentario,
    }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al guardar puntuación");
  }

  return data.isSaved;
}

// ✅ Obtener puntuaciones de una guardia
export async function getPuntuacionesByGuardia(idguardia) {
  const token = getAuthToken();
  const response = await fetch(
    `${CALL_API}/getpuntuacionesbyguardia/${idguardia}`,
    {
      headers: { Authorization: "Bearer " + token },
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al obtener puntuaciones");
  }

  return data.result;
}

// ✅ Obtener promedios globales de profesionales
export async function getPromedioProfesionales() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getpromedioprofesionales`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al obtener promedios globales");
  }

  return data.result;
}

// ✅ Obtener puntuaciones entre fechas
export async function getPuntuacionesByFecha(fechainicio, fechafin) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getpuntuacionesbyfecha`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ fechainicio, fechafin }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al obtener puntuaciones por fecha");
  }

  return data.result;
}

// ✅ Obtener promedio por fecha (ranking filtrado)
export async function getPromedioByFecha(fechainicio, fechafin) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getpromediobyfecha`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ fechainicio, fechafin }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al obtener promedios por fecha");
  }

  return data.result;
}

// ✅ Obtener puntuación específica por IDs
export async function getPuntuacionByIds(idlegajo, idprofesional, idpaciente) {
  const token = getAuthToken();
  const response = await fetch(
    `${CALL_API}/getpuntuacionbyids/${idlegajo}/${idprofesional}/${idpaciente}`,
    {
      headers: { Authorization: "Bearer " + token },
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al obtener puntuación");
  }

  return data.result;
}
